import { LeagueTableChartConfig } from "~/modules/charts/types";
import { LeagueTableChartProvider } from "./LeagueTableChartProvider";

// // // //

/**
 * LeagueTableChartRenderer
 * Renders a league table chart with one tab per configured group. The tabs are
 * built server-side from the token aggregates API.
 */
export function LeagueTableChartRenderer(props: {
    title: string;
    config: LeagueTableChartConfig;
}) {
    const { title, config } = props;

    return (
        <LeagueTableChartProvider title={title} config={config}>
            {({ isLoading, isEmpty, chartEl, emptyEl, loadingEl }) => (
                <>
                    {isLoading && <>{loadingEl}</>}
                    {!isLoading && isEmpty && <>{emptyEl}</>}
                    {!isLoading && !isEmpty && <>{chartEl}</>}
                </>
            )}
        </LeagueTableChartProvider>
    );
}
